import imagePlaceholder from '@/assets/placeholder.png';
import List from '@/models/List';
import { ApplicationState } from '@/store';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';

type SearchCourseListProps = {
    courses: List[];
    title: string;
    onAddCourse: (course: List) => void;
};

const SearchCourseList: React.FC<SearchCourseListProps> = ({ courses = [], title = '', onAddCourse }: SearchCourseListProps) => {
    const strings = useSelector((state: ApplicationState) => state.locale.data);

    const formatItemString = (item: List) => (item.lessonAmount && item?.lessonAmount > 1 ? strings.ITEMS : strings.ITEM);

    return (
        <>
            {courses && courses.length > 0 && <span className="showing-category">{title}</span>}
            {courses &&
                courses.map((course: List) => (
                    <>
                        <div className="item-card-list-list-search-course" id={`course_${course.id}`} key={course.id}>
                            <div className="item-card-main-content">
                                <div className="content-top">
                                    <img alt="" src={course.mainImage || imagePlaceholder} />
                                    <span className="item-title" title={course.name}>
                                        {course.name}
                                    </span>
                                </div>

                                <div className="item-card-content">
                                    <span className="item-info-key">
                                        <span className="item-info-value">
                                            {course.lessonAmount || 0} {formatItemString(course)}
                                        </span>
                                        <span className="item-info-value">{course.workload && `${course.workload} min`}</span>
                                    </span>
                                </div>
                            </div>

                            <div className="item-card-footer">
                                <button className="btn course-add" onClick={() => onAddCourse(course)}>
                                    <span className="add-btn">{strings.ADD_COURSE}</span>
                                </button>
                            </div>
                        </div>
                    </>
                ))}
        </>
    );
};

export default memo(SearchCourseList);
